export default __webpack_public_path__ + "static/media/members-preview.9fd216bd.png";